module.exports = __webpack_public_path__ + "static/media/benni.48008ea3.jpg";